import React from 'react'
import { sectionDisplayIndex, hasElement, sortMapping } from '../../../lib'
import TextTable from '../../../components/TextTable'
import UnitElement from '../../components/UnitElement'

export default function UnitElementSection({
  displayMapped,
  mappedElements,
  section,
  sectionIndex,
}) {
  const mapping = sortMapping(
    []
      .concat(
        section.mapping,
        ...section.subsections.map(({ mapping }) => mapping),
      )
      .reduce((mapping, element) => {
        if (!hasElement(element, mapping)) {
          mapping.push(element)
        }
        return mapping
      }, []),
  )
  return (
    <TextTable
      displayDisabled={displayMapped}
      heading={`${sectionDisplayIndex(...sectionIndex)} - ${section.name}`}
      noRowsMsg={
        mapping.length === 0
          ? 'No mapping associated with this section'
          : 'All elements mapped.'
      }
      rows={mapping.map(({ type, index }) => ({
        type,
        index,
        disabled: hasElement({ type, index }, mappedElements),
      }))}
      component={({ children: { type, index } }) =>
        <UnitElement type={type} index={index} />}
    />
  )
}



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/SummativePractical/UnitElementSection.js